<template>
    <h1>Vista de Listagem de Avaliações Descendentes</h1>
    <AssessmentQuestionaireManagementTable 
        :assessment-type="'downward'"
    />
</template>
<script setup>
import AssessmentQuestionaireManagementTable from '@/components/assessments/questionaires/AssessmentQuestionaireManagementTable.vue';


</script>